import React from "react";
import NavBar from "../NavBar/NavBar";
import Footer from "./Footer";

const Cookies = () => {
  return (
    <div className="cookies common__bg__cyan">
      <NavBar />
      <div className="container mt-3">
        <h1 className="mb">COOKIES POLICY</h1>
        <p className="mb">
        Cookies are a file that is downloaded to the computer when accessing certain web pages, allowing the storage and retrieval of information about the browsing habits of a user or their equipment (among other things). Depending on the information they contain and the way the equipment is used, they can be used to recognize the user. The user's browser memorizes cookies on the hard drive only during the current session, occupying a minimum memory space and without harming the computer. Cookies do not contain any kind of specific personal information and most are deleted from the hard drive at the end of the browser session (session cookies).
        Many browsers accept cookies as standard and, regardless of their type, allow or prevent temporary or memorized cookies in the security settings.
        </p>
        <p className="mb">
          Many browsers accept cookies as standard and,
          regardless of the type they are, they allow or prevent cookies
          temporary or memorized in the security settings.
        </p>
        <p className="mb">
          Without your express consent - by activating cookies
          in the browser–, bainba.com will not link the data in the cookies
          memorized with personal information provided at the time of
          registration or purchase.
        </p>
        <p className="mb">What types of cookies does this website use?</p>
        <p className="mb">
          - Technical cookies. They allow navigation through a web page,
          platform or application, as well as the use of different
          options or services: control traffic and data communication,
          identify the session, access restricted parts, remember the
          elements that make up an order, make the purchase of an order,
          make the request for registration or participation in an event,
          use security elements while browsing, store
          content for broadcasting videos or sound, or sharing content
          Through social networks.
        </p>
        <p className="mb">
          - Personalization cookies. They allow access to the service with some
          predefined general characteristics based on a series of
          criteria in the user's terminal: language, browser type
          through which you access the service, the regional configuration from
          where you access the service, etc.
        </p>
        <p className="mb">
          - Analysis cookies. Whether processed by us or by third parties,
          allow to quantify the number of users and thus carry out the measurement
          and statistical analysis on the use of the service offered.
          For this, the navigation on the website is analyzed in order to improve
          the offer of products and / or services.
        </p>
        <p className="mb">
          - Third party cookies. bainba.com may use third party services
          that will collect information for statistical purposes on the use of the
          website by the user, as well as for the provision of
          services related to the activity of the website and other
          Internet services.
        </p>
        <p className="mb">Specifically, this website uses:</p>
        <p>Addthis</p>
        <p className="mb">
          It is a service that allows the content of bainba.com to be shared in
          social networks through identification icons. Use cookies
          techniques for its operation and personalization cookies for
          remember the configuration that the user makes of the icons of the
          social media.
        </p>
        <p className="mb">http://www.addthis.com/privacy</p>
        <p>Facebook</p>
        <p className="mb">
          bainba.com uses different Facebook services which, in turn,
          They make use of technical and personalization cookies. These services
          they are the «like box» and the «like button».
        </p>
        <p className="mb">http://es-es.facebook.com/help/cookies</p>
        <p>Youtube</p>
        <p className="mb">
          bainba.com shows Youtube videos in different sections of the site
          Web. These videos make use of technical and personalization cookies
          for its correct operation.
        </p>
        <p className="mb">
          https://www.google.com/policies/technologies/cookies/
        </p>
        <p className="mb">
          This website also uses Google Analytics, an analytical service
          website offered by Google Inc., headquartered at 1600 Amphitheater
          Parkway, Mountain View, California 94043 (United States). For the
          provision of these services cookies are used that collect all
          the information (including the user's IP address), which will be
          transmitted, processed and stored by Google in the terms set
          on webGoogle.com. This supposes the possible transmission of this
          information to third parties for reasons of legal requirement or in order to be
          processed by Google account.
        </p>
        <p className="mb">
          By using this website, the user expressly accepts the
          treatment of the information collected in the form and for the purposes
          previously mentioned. It also recognizes the possibility of
          reject the processing of such data or information through the
          selection of the appropriate settings for this purpose in your browser.
          However, it is possible that this option to block cookies in
          the browser does not allow full use of all the functionalities of the
          website.
        </p>
        <p className="mb">
          You can allow, block or delete installed cookies
          by configuring the browser options:
        </p>
        <p>Chrome</p>
        <p>Explorer</p>
        <p>Firefox </p>
        <p>Safari</p>
        <p>
          If you have questions about this cookie policy, you can contact
          mentex.com (mentex@gmail.com).
        </p>
      </div>
      <Footer />
    </div>
  );
};

export default Cookies;